import { lazy } from 'react';

import type { CmsApiThreeSectionSliderBlockData } from '#/modules/cms/api/types/blocks/CmsApiThreeSectionSliderBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsThreeSectionSliderBlockMapping: CmsBlockMapping<CmsApiThreeSectionSliderBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Three Section Slider',
      },
      {
        prop: 'sections',
        msg: 'Sections required for Three Section Slider',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: lazy(() =>
      import('./CmsThreeSectionSliderBlock').then((m) => ({
        default: m.CmsThreeSectionSliderBlock,
      })),
    ),
  };
